import React from 'react';
import Relay from 'react-relay';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import FlowDefTestsView from './FlowDefTestsView';
import { SnapshotFiltersState } from './SnapshotFilters';
import { Snapshot } from './SnapshotGrid';
import { compareTimestampsNewestFirst } from './snapshotTimestamp';
// @ts-ignore
import types from '../../common/model-api/types';

interface Props {
    user: {
        testInvocations: {
            edges: Array<{
                node: Snapshot
            }>
        }
    };
    params: {
        flowDefId: string;
    };
}

interface State {
    filters: SnapshotFiltersState;
}

export class FlowDefTestsViewContainer extends React.Component<Props & InjectedIntlProps, State> {
    state: State = {
        filters: {
            search: '',
            status: '',
            sortBy: 'name'
        }
    };

    handleFilterChange = (filters: SnapshotFiltersState) => {
        this.setState({ filters });
    };

    getFilteredSnapshots(): Snapshot[] {
        const { testInvocations } = this.props.user;
        const list = testInvocations ? testInvocations.edges.map(e => e.node) : [];
        const { filters } = this.state;

        return list
            .filter(s => {
                const matchesSearch = s.name.toLowerCase().includes(filters.search.toLowerCase());
                const matchesStatus = filters.status ? s.lastStatus === filters.status : true;
                return matchesSearch && matchesStatus;
            })
            .sort((a, b) => {
                if (filters.sortBy === 'name') {
                    return a.name.localeCompare(b.name);
                } else if (filters.sortBy === 'updatedAt') {
                    return compareTimestampsNewestFirst(a.updatedAt, b.updatedAt);
                }
                return 0;
            });
    }

    render() {
        const { filters } = this.state;
        const { flowDefId } = this.props.params;
        const filteredSnapshots = this.getFilteredSnapshots();

        const breadcrumbParams = [
            { type: types['flowDefs'], data: { realId: flowDefId, id: flowDefId, name: 'Flow Definition' } },
            { type: { entity: () => 'snapshotTesting', getDefaultTitle: () => 'Snapshots' }, data: { name: 'Snapshots' } }
        ];

        return (
            <FlowDefTestsView
                breadcrumbParams={breadcrumbParams}
                filters={filters}
                onFilterChange={this.handleFilterChange}
                snapshots={filteredSnapshots}
                title={this.props.intl.formatMessage({ id: 'snapshotTesting.manageTitle', defaultMessage: 'Snapshot Management' })}
            />
        );
    }
}

export default Relay.createContainer(injectIntl(FlowDefTestsViewContainer), {
    initialVariables: {
        flowDefId: null,
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                testInvocations(flowDefId: $flowDefId, first: 1000) {
                    edges {
                        node {
                            id
                            realId
                            name
                            organisation_id
                            flow_id
                            sourceFlowInvocation_id
                            lastStatus
                            updatedAt
                            expectedOutputPreview
                        }
                    }
                }
            }
        `,
    },
});
